import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export const NumberOfBooksCheck = {
  Check: 'Y',
  NotCheck: 'N'
} as const
export type NumberOfBooksCheck = typeof NumberOfBooksCheck[keyof typeof NumberOfBooksCheck]

export const AppendixCheck = {
  Check: 'Y',
  NotCheck: 'N'
} as const
export type AppendixCheck = typeof AppendixCheck[keyof typeof AppendixCheck]

export const UnregisteredCheck = {
  CheckLendImpossible: '0',
  CheckLendPossible: '1',
  NotCheckLendPossible: '2'
} as const
export type UnregisteredCheck = typeof UnregisteredCheck[keyof typeof UnregisteredCheck]

export const IdentificationCheck = {
  Check: 'Y',
  NotCheck: 'N',
  Person: 'P',
  Other: 'O'
} as const
export type IdentificationCheck = typeof IdentificationCheck[keyof typeof IdentificationCheck]

export const LendExtensionCheck = {
  NotCheckExtensionImpossible: '0',
  CheckExtensionImpossible: '1',
  CheckExtensionPossible: '2'
} as const
export type LendExtensionCheck = typeof LendExtensionCheck[keyof typeof LendExtensionCheck]

export const ReserveExtensionCheck = {
  NotCheckExtensionImpossible: '0',
  CheckExtensionImpossible: '1',
  CheckExtensionPossible: '2'
} as const
export type ReserveExtensionCheck = typeof ReserveExtensionCheck[keyof typeof ReserveExtensionCheck]

export const DelayExtensionCheck = {
  NotCheckExtensionImpossible: '0',
  CheckExtensionImpossible: '1',
  CheckExtensionPossible: '2'
} as const
export type DelayExtensionCheck = typeof DelayExtensionCheck[keyof typeof DelayExtensionCheck]

export const DueDateType = {
  CalculateOpenDays: 'K',
  CalculateAfterConsiderClose: 'Y',
  CalculateAfterNotConsiderClose: 'N'
} as const
export type DueDateType = typeof DueDateType[keyof typeof DueDateType]

export const ExtendDueDateType = {
  CalculateOpenDays: 'K',
  CalculateAfterConsiderClose: 'Y',
  CalculateAfterNotConsiderClose: 'N'
} as const
export type ExtendDueDateType = typeof ExtendDueDateType[keyof typeof ExtendDueDateType]

export const ExtendAdditionalType = {
  AddSystemDate: '1',
  AddReturnDueDate: '2',
  AddSystemDateOrReturnDueDate: '4'
} as const
export type ExtendAdditionalType = typeof ExtendAdditionalType[keyof typeof ExtendAdditionalType]

export interface CollectionAndUserCheck {
  id: number
  branchCode: SystemCode
  lendType: SystemCode
  numberOfBooksCheck: NumberOfBooksCheck
  appendixCheck: AppendixCheck
  unregisteredCheck: UnregisteredCheck
  identificationCheck: IdentificationCheck
  lendExtensionCheck: LendExtensionCheck
  reserveExtensionCheck: ReserveExtensionCheck
  delayExtensionCheck: DelayExtensionCheck
  dueDateType: DueDateType
  extendDueDateType: ExtendDueDateType
  extendAdditionalType: ExtendAdditionalType
  revision: number
}

export const defaultCollectionAndUserCheck = (): CollectionAndUserCheck => ({
  id: 0,
  branchCode: defaultSystemCode(),
  lendType: defaultSystemCode(),
  numberOfBooksCheck: NumberOfBooksCheck.Check,
  appendixCheck: AppendixCheck.Check,
  unregisteredCheck: UnregisteredCheck.CheckLendImpossible,
  identificationCheck: IdentificationCheck.Check,
  lendExtensionCheck: LendExtensionCheck.CheckExtensionImpossible,
  reserveExtensionCheck: ReserveExtensionCheck.CheckExtensionImpossible,
  delayExtensionCheck: DelayExtensionCheck.CheckExtensionImpossible,
  dueDateType: DueDateType.CalculateOpenDays,
  extendDueDateType: ExtendDueDateType.CalculateOpenDays,
  extendAdditionalType: ExtendAdditionalType.AddSystemDate,
  revision: 0
})

export function CollectionAndUserCheckFromJSON(
  json: any
): CollectionAndUserCheck {
  return {
    id: exists(json, 'id') ? json.id : 0,
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    lendType: exists(json, 'lend_type')
      ? SystemCodeFromJSON(json.lend_type)
      : defaultSystemCode(),
    numberOfBooksCheck: exists(json, 'number_of_books_check')
      ? json.number_of_books_check
      : NumberOfBooksCheck.Check,
    appendixCheck: exists(json, 'appendix_check')
      ? json.appendix_check
      : AppendixCheck.Check,
    unregisteredCheck: exists(json, 'unregistered_check')
      ? json.unregistered_check
      : UnregisteredCheck.CheckLendImpossible,
    identificationCheck: exists(json, 'identification_check')
      ? json.identification_check
      : IdentificationCheck.Check,
    lendExtensionCheck: exists(json, 'lend_extension_check')
      ? json.lend_extension_check
      : LendExtensionCheck.CheckExtensionImpossible,
    reserveExtensionCheck: exists(json, 'reserve_extension_check')
      ? json.reserve_extension_check
      : ReserveExtensionCheck.CheckExtensionImpossible,
    delayExtensionCheck: exists(json, 'delay_extension_check')
      ? json.delay_extension_check
      : DelayExtensionCheck.CheckExtensionImpossible,
    dueDateType: exists(json, 'due_date_type')
      ? json.due_date_type
      : DueDateType.CalculateOpenDays,
    extendDueDateType: exists(json, 'extend_due_date_type')
      ? json.extend_due_date_type
      : ExtendDueDateType.CalculateOpenDays,
    extendAdditionalType: exists(json, 'extend_additional_type')
      ? json.extend_additional_type
      : ExtendAdditionalType.AddSystemDate,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
